export const labelsFilterFn = (
  key: string,
  labels: Record<string, string>,
  keyword: string,
) => {
  return `${labels[key]} ${key}`.toLowerCase().includes(keyword.toLowerCase());
};
